function capitalizePeriodo (s) {
    if (typeof s !== 'string') return ''
    const text = s.split(' ');
    return `${text[0]} - ${text[1].charAt(0).toUpperCase() + text[1].slice(1).toLocaleLowerCase()}`;
}

function removerAcentos(string) {
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}


export default {
    capitalizePeriodo,
    removerAcentos
}
